import React, { useCallback, useImperativeHandle } from 'react';
import { Button, withTheme } from '@rneui/themed';
import * as Progress from 'react-native-progress';
import { useCachedProgressItemQuery, useProgressItemMutation, useIsEntitledQuery, } from '@annunciate/query';
import { PositionType, messageFactory, Topic, useUserUUID, } from '@annunciate/core';
import { FAIcon } from '../elements';
import { getProgressPercent } from '../../utils/progress';
export const UnthemedProgressButton = React.forwardRef(({ item, isLeftAligned, isRightAligned, size = 10, activeIconColor, iconColor, }, ref) => {
    const uuid = useUserUUID();
    const { data } = useCachedProgressItemQuery(item.id);
    const { mutate } = useProgressItemMutation();
    const isEntitled = useIsEntitledQuery(item);
    const onToggle = useCallback((isCompleted) => {
        const payload = {
            item: {
                type: 'content',
                id: item.id,
            },
        };
        if (!isCompleted) {
            mutate({
                contentId: item.id,
                position: {
                    type: PositionType.COMPLETED,
                },
                sync: true,
            });
            messageFactory(Topic.CONTENT_STATUS_COMPLETED, payload);
        }
        else {
            mutate({
                contentId: item.id,
                position: null,
                sync: true,
            });
            messageFactory(Topic.CONTENT_STATUS_UNCOMPLETED, payload);
        }
    }, [
        item?.id,
    ]);
    let progress = 0;
    if (data) {
        progress = getProgressPercent(data);
    }
    const isCompleted = progress > .9;
    const color = progress > 0 ? activeIconColor : iconColor;
    useImperativeHandle(ref, () => {
        return { toggle: () => onToggle(isCompleted) };
    }, [onToggle, isCompleted]);
    if (!uuid || !isEntitled) {
        return null;
    }
    return (React.createElement(Button, { type: "clear", onPress: () => onToggle(isCompleted), isLeftAligned: isLeftAligned, isRightAligned: isRightAligned },
        React.createElement(Progress.Circle, { progress: progress, size: Math.round(size), showsText: true, color: color, fill: "transparent", formatText: () => (React.createElement(FAIcon, { name: "check", color: color, style: {
                    fontSize: size ? size * 0.5 : undefined,
                } })) })));
});
export const ProgressButton = withTheme(UnthemedProgressButton, 'ProgressButton');
//# sourceMappingURL=ProgressButton.js.map